module.exports = __webpack_public_path__ + "static/media/usn-4.260e3ef2.jpg";